/**
 * Impl dos use cases de Bolsa (commerce).
 *
 * @since G.5.20
 */
import type { Desconto } from '@/domain/model/Desconto';
import type { CriarBolsaCommand, AprovarBolsaCommand, RevogarBolsaCommand } from '@/domain/model/Bolsa';
import type { BolsaGateway } from '@/application/port/out/BolsaGateway';
import type {
  SolicitarBolsaUseCase, AprovarBolsaUseCase, RevogarBolsaUseCase,
} from '@/application/port/in/BolsaUseCase';

export class SolicitarBolsa implements SolicitarBolsaUseCase {
  constructor(private readonly g: BolsaGateway) {}
  execute(cmd: CriarBolsaCommand): Promise<Desconto> { return this.g.solicitar(cmd); }
}
export class AprovarBolsa implements AprovarBolsaUseCase {
  constructor(private readonly g: BolsaGateway) {}
  execute(id: string, cmd: AprovarBolsaCommand): Promise<Desconto> { return this.g.aprovar(id, cmd); }
}
export class RevogarBolsa implements RevogarBolsaUseCase {
  constructor(private readonly g: BolsaGateway) {}
  execute(id: string, cmd: RevogarBolsaCommand): Promise<Desconto> { return this.g.revogar(id, cmd); }
}
